import type { ReactNode } from "react";
import { EmptyState } from "./Feedback";

export interface DataTableColumn<Row> {
  align?: "start" | "center" | "end";
  header: ReactNode;
  id: string;
  render: (row: Row) => ReactNode;
  width?: string;
}

export interface DataTableProps<Row> {
  caption?: string;
  columns: Array<DataTableColumn<Row>>;
  empty?: ReactNode;
  getRowKey: (row: Row, index: number) => string;
  rows: Row[];
}

export function DataTable<Row>({ caption, columns, empty, getRowKey, rows }: DataTableProps<Row>) {
  if (rows.length === 0) {
    return <>{empty ?? <EmptyState compact description="Records will appear here when they are available." title="No records yet" />}</>;
  }

  return (
    <div className="am-table-wrap">
      <table className="am-table">
        {caption && <caption>{caption}</caption>}
        <thead>
          <tr>{columns.map((column) => <th key={column.id} scope="col" style={{ textAlign: column.align, width: column.width }}>{column.header}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={getRowKey(row, rowIndex)}>
              {columns.map((column) => <td data-label={typeof column.header === "string" ? column.header : undefined}
                key={column.id} style={{ textAlign: column.align }}>{column.render(row)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
